import { render, staticRenderFns } from "./ProgramSubVideo.vue?vue&type=template&id=d78979e0&"
import script from "./ProgramSubVideo.vue?vue&type=script&lang=js&"
export * from "./ProgramSubVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports